module.exports = __webpack_public_path__ + "img/banner_coun_guide_01.15116201.png";